module.exports = __webpack_public_path__ + "img/item-coment-blog-single2.1ba01528.jpg";